<template>
    <div>
        <base-crud
                crudName="Pontos Manuais"
                newText="Novo Ponto Manual"
                :table="tableName"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :dataForm="dataForm"
                :toadd="'/manualCheck'"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                tableName: 'manualChecksTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'user_id', 'created_at', 'actions'],
                tableData: ['id', 'user_id', 'created_at'],
                options: {
                    filterByColumn: true,
                    filterable: ['id', 'user_id', 'created_at'],
                    sortable: ['id', 'user_id', 'created_at'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'user_id': 'Usuário',
                        'created_at': 'Data e Hora',
                        'actions' : 'Ações'
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = ['user'];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    },
                    templates: {
                        user_id: function(h, row, index) {
                            return row.user.name;
                        },
                    },
                },
                endPoint: 'checks/',

                dataForm: {}
            }
        },
        components: {
            BaseCrud
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    user_id: 'user[name]',
                    created_at: 'created_at',
                };
                let filters = 'manual=1&';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
            }
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ManualCheck/Crud.vue